/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateContactRequestContact,
  CreateContactRequestContactFromJSON,
  CreateContactRequestContactFromJSONTyped,
  CreateContactRequestContactToJSON
} from './CreateContactRequestContact'

/**
 *
 * @export
 * @interface CreateContactRequest
 */
export interface CreateContactRequest {
  /**
   *
   * @type {CreateContactRequestContact}
   * @memberof CreateContactRequest
   */
  contact?: CreateContactRequestContact
}

export function CreateContactRequestFromJSON(json: any): CreateContactRequest {
  return CreateContactRequestFromJSONTyped(json, false)
}

export function CreateContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateContactRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    contact: !exists(json, 'contact') ? undefined : CreateContactRequestContactFromJSON(json['contact'])
  }
}

export function CreateContactRequestToJSON(value?: CreateContactRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    contact: CreateContactRequestContactToJSON(value.contact)
  }
}
